module.exports = __webpack_public_path__ + "static/media/feedback.d34ce0ef.png";